export default __webpack_public_path__ + "static/media/portfolio-smc360-2.c1370343.jpg";